import { SiteManagementTab } from './types';
import { StatusType } from './LocationsList/types';
export const tabLabelsMap: Record<SiteManagementTab, string> = {
  locations: 'All Locations',
  groups: 'Location Groups',
};

export const getIsDeleted = (status: StatusType) => {
  switch (status) {
    case 'ALL':
      return undefined;
    case 'DELETED':
      return true;
    default:
      return false;
  }
};
